<template>
  <div class="full-page-width">
    <div class="drafts relative">
      <div class="add-button c-float m-b-20 flex is-flex-wrap">
        <div class="flex" style="flex-grow: 1">
          <p class="user-name">{{ $t('drafts') }}</p>
        </div>
        <Dropdown
          class="flex drop-right"
          :buttonText="$t('add')"
          :dropdownOptions="dropdownOptions"
          @optionSelected="optionSelected" />
      </div>
      <DataTable
        :dropdown=false
        :tableHeader=true
        :tableHead=true
        tableAPI="DRAFT_SHIPMENTS"
        tableActions="DRAFT_SHIPMENTS"
        :actionsOptions="actionsOptions"
        :totalCount="totalCount"
        :checkbox=true
        :type="type"
        :count="get_drafts_count"
        :list="get_drafts_list"
        :rowActionParameter="rowActionParameter"
        :referenceData="referenceData"
        :filterOptions="filterOptions"
        :customTable=false
        :updateIterator="updateIterator"
        :useExcludeLogic=true
        @updatedSelections="tableSelectionsUpdated"
        @actionOptionTriggered="actionOptionTriggered"
        @rowAction="rowAction" />
      <Popup
        v-if="openImport"
        :showConfirmButton="showImportButton && !get_error_message"
        :confirmText="$t('import')"
        @cancel="togglePopupEdit"
        @confirm="submitForm">
        <template v-slot:header>
          <h2>{{ $t('Import Template') }}</h2>
        </template>
        <UploadTemplate
          @enabeImport="enableImport"
          @disableImport="showImportButton = false"
          @closePopup="closePopupAndTrackImportProcess"
          @uploaded="updateTableAfterUpload"
          templateType="shipment_fields" />
        <message
          v-if="get_error_message.type"
          name="warning"
          :data="get_error_message" />
      </Popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import DataTable from '@/components/table/index.vue';
import Popup from '@/components/global/popup';
import Dropdown from '@/components/global/dropdown';
import UploadTemplate from '@/components/global/uploadTemplate';
import EventBus from '@/eventBus.js';

/* eslint-disable */
export default {
  name: 'Drafts',
  components: { DataTable, Btn, Popup, UploadTemplate, Dropdown },
  data() {
    return {
      updateIterator: 1,
      isTableAllSelected: false,
      totalCount: 300,
      excludeOnlyIds: [],
      selectedCount: 0,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('View draft')}`,
      },
      type: {
        type: true,
        data: 'status',
        text: `${this.$t('status')}`,
        icons: {
          1: 'check',       // ready
          8: 'warningSign', // kad ima gresku
          17: 'printer',    // - processing
          36: 'warningSign' //agent error
        },
      },
      referenceData: [
        {
          created_at: `${this.$t('created_at')}`,
          agent_and_product: `${this.$t('carrier_product')}`,
        },
        {
          receiver_name: `${this.$t('receiver')}`,
          customer_address_country_name: `${this.$t('country')}`,
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          source_and_user: `${this.$t('Source')} - ${this.$t('user')}`,
        },
      ],
      dropdownOptions: [
        {
          text: `${this.$t('Create Shipment')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
        {
          text: `${this.$t('upload_shipments')}`,
          subText: `${this.$t('Bulk import from file')}`,
          icon: 'cloudUpload',
        },
      ],
      actionsOptions: [
        {
          text: `${this.$t('Delete drafts')}`,
          subText: `${this.$t('Delete selections')}`,
          icon: 'deleteForever',
        },
        {
          text: `${this.$t('print')}`,
          subText: `${this.$t('print')}`,
          icon: 'printer',
        },
      ],
      openImport: false,
      showImportButton: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_drafts_list',
      'get_drafts_count',
      'get_filters_menu',
      'get_active_filter',
      'get_all_shipments_query',
      'get_import_queue',
    ]),
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'drafts',
        tableApi: 'shipment/get-draft-list',
        filterFields: {
          create_type: {
            label: `${this.$t('Source')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('App')}`, value: 'app'},
              {text: `${this.$t('upload_template')}`, value: 'upload'},
              {text: 'Api', value: 'api'}
            ],
          },
          status: {
            label: `${this.$t('status')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('ready')}`, value: '1'},
              {text: `${this.$t('error')}`, value: '8'},
              {text: `${this.$t('processing')}`, value: '17'},
              {text: `${this.$t('Carrier Error')}`, value: '36'}
            ],
          },
          ship_date: {
            label: `${this.$t('ship_date')}`,
            type: 'date',
            range: true,
            value: {
              value: null,
              additional: '',
            },
          },
          created_at: {
            label: `${this.$t('created_at')}`,
            range: true,
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          subaccount_id: {
            label: `${this.$t('account')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          custom_tags: {
            label: `${this.$t('Tags')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_agent_name: {
            label: `${this.$t('shipping_agent_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_product_name: {
            label: `${this.$t('Product name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          weight: {
            label: `${this.$t('weight')}`,
            type: 'options',
            value: {
              value: '',
              additional: '',
            },
          },
          goods_type: {
            label: `${this.$t('goods_type')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('parcel')}`, value: '1'},
              {text: `${this.$t('document')}`, value: '2'},
              {text: `${this.$t('pallet')}`, value: '3'},
              {text: `${this.$t('load')}`, value: '4'},
            ],
          },
          receiver_reference: {
            label: `${this.$t('reciever_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_company_name: {
            label: `${this.$t('receiver_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_name: {
            label: `${this.$t('receiver_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_address: {
            label: `${this.$t('receiver_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_post_code: {
            label: `${this.$t('receiver_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_country_id: {
            label: `${this.$t('receiver_country_id')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
          sender_reference: {
            label: `${this.$t('sender_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_company_name: {
            label: `${this.$t('sender_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_name: {
            label: `${this.$t('sender_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_address: {
            label: `${this.$t('sender_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_post_code: {
            label: `${this.$t('sender_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_country_id: {
            label: `${this.$t('sender_country_id')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
          goods_incoterm: {
            label: `${this.$t('goods_incoterm')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: 'DAP', value: 'DAP'},
              {text: 'DDP', value: 'DDP'},
              {text: 'EXW', value: 'EXW'},
              {text: 'FCA', value: 'FCA'},
              {text: 'CPT', value: 'CPT'},
              {text: 'CIP', value: 'CIP'},
              {text: 'DPU', value: 'DPU'},
              {text: 'FAS', value: 'FAS'},
              {text: 'FOB', value: 'FOB'},
              {text: 'CFR', value: 'CFR'},
              {text: 'CIF', value: 'CIF'},
            ],
          },
          duty_paid_by: {
            label: `${this.$t('duty_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('duty_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Reciever').toLowerCase()}`, value: '2'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Third party').toLowerCase()}`, value: '3'},
            ],
          },
          freight_paid_by: {
            label: `${this.$t('freight_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('freight_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('freight_paid_by')} ${this.$t('Other').toLowerCase()}`, value: '2'},
            ],
          },
        },
      }
    },
  },
  methods: {
    updateTableAfterUpload() {
      this.updateIterator++;
    },
    tableSelectionsUpdated(payload) {
      this.isTableAllSelected = payload.selectTotalRows;
      this.excludeOnlyIds = payload.excludeOnlyIds || [];
      this.selectedCount = payload.totalSelected || 0;
    },
    rowAction(val) {
      let shipmentId = this.get_drafts_list.filter((item) => item.id == val)[0].id;
      this.$store.dispatch('GET_SINGLE_DRAFT', shipmentId).then((res) => {
        this.$store.dispatch('SET_EDITING_SHIPMENT', {
          shipmentType: 'draft',
          ...res,
        }).then(() => {
          this.$router.push('book-shipment');
        });
      });
    },
    actionOptionTriggered(option) {
      if(option.dropOption == 'dropOption1') {
        this.handleDeleteAction(option);
      }
      if(option.dropOption == 'dropOption2') {
        this.handlePrintAction(option);
      }
    },
    handleDeleteAction(option) {
      // Determine if this is a bulk deletion (threshold can be adjusted)
      const isBulkDeletion = option.selectTotalRows || option.list.length > 10;

      if (option.selectTotalRows && option.excludeOnlyIds !== undefined) {
        // Use exclude logic for bulk deletion
        this.$store.dispatch('DELETE_DRAFTS', {
          type: 'byFilterWithExclusions',
          search: this.$route.query.search || null,
          searchTerm: this.$route.query.searchTerm || null,
          // Send the raw filtered total; the backend subtracts excludeOnlyIds.length itself
          // to compute the expected count. Pre-subtracting here double-counts the exclusion.
          count: this.get_drafts_count,
          excludeOnlyIds: option.excludeOnlyIds,
        }).then((response) => {
          // deletedCount is the number of rows actually deleted (total minus excluded),
          // not the number of excluded ids.
          this.handleDeleteSuccess(response, true, this.get_drafts_count - option.excludeOnlyIds.length, option);
        }).catch((error) => {
          this.handleDeleteError(error);
        });
      } else {
        // Standard behavior with selected IDs
        this.$store.dispatch('DELETE_DRAFTS', {
          type: 'byId',
          id: 0,
          ids: option.list,
        }).then((response) => {
          this.handleDeleteSuccess(response, isBulkDeletion, option.list.length, option);
        }).catch((error) => {
          this.handleDeleteError(error);
        });
      }
    },
    handleDeleteSuccess(response, isBulkDeletion, deletedCount, option) {
      if (isBulkDeletion) {
        // For bulk deletions, calculate appropriate page and do full refresh
        const newTotalCount = this.get_drafts_count - deletedCount;
        const itemsPerPage = 50;
        const maxPossiblePage = Math.ceil(newTotalCount / itemsPerPage);

        // Calculate current position and adjust page if necessary
        const currentPosition = (this.loadedPage - 1) * itemsPerPage;
        let targetPage = Math.ceil((currentPosition + 1) / itemsPerPage);

        // Ensure target page is within valid range
        targetPage = Math.min(targetPage, Math.max(1, maxPossiblePage));

        // Update the loadedPage in DataTable before triggering refresh
        this.$children.forEach(child => {
          if (child.$options.name === 'DataTable') {
            child.loadedPage = targetPage;
            child.pageEnd = false;
          }
        });

        this.updateIterator++;

        // Show bulk deletion notification
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('LBL_BULK_DELETION_COMPLETED'),
          type: 'success-window',
          iconName: 'check',
        });
      } else {
        // For small deletions, remove items locally to preserve pagination
        if (option.selectTotalRows && option.excludeOnlyIds !== undefined) {
          // For exclude logic, we need to refresh since we don't know exact deleted items
          this.updateIterator++;

          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: this.$t('LBL_DRAFTS_DELETED_SUCCESSFULLY', { count: deletedCount }),
            type: 'success-window',
            iconName: 'check',
          });
        } else {
          // Remove specific items from the current list
          option.list.forEach(deletedId => {
            this.$store.commit('REMOVE_DRAFT_FROM_LIST', deletedId);
          });

          // Update counts
          this.$store.commit('UPDATE_DRAFTS_COUNT', this.get_drafts_count - option.list.length);

          // Show local deletion notification
          if (deletedCount === 1) {
            this.$store.commit('SHOW_NOTIFICATION_BAR', {
              message: this.$t('LBL_DRAFT_DELETED_SUCCESSFULLY'),
              type: 'success-window',
              iconName: 'check',
            });
          } else {
            this.$store.commit('SHOW_NOTIFICATION_BAR', {
              message: this.$t('LBL_DRAFTS_DELETED_SUCCESSFULLY', { count: deletedCount }),
              type: 'success-window',
              iconName: 'check',
            });
          }
        }
      }

      // Reset selections
      this.resetTableSelections();
    },
    handleDeleteError(error) {
      this.$store.commit('SHOW_NOTIFICATION_BAR', {
        message: this.$t('LBL_DELETE_FAILED_ERROR'),
        type: 'alert-window',
        iconName: 'warningSign',
      });
    },
    resetTableSelections() {
      // Reset selections in the DataTable component
      this.$children.forEach(child => {
        if (child.$options.name === 'DataTable') {
          child.selectedItems = [];
          child.excludedItems = [];
          child.selectTotalRows = false;
        }
      });
    },
    handlePrintAction(option) {
      let payloadObject;
      if (option.selectTotalRows && option.excludeOnlyIds !== undefined) {
        // Use exclude logic
        payloadObject = {
          shipment_ids: null,
          search: this.$route.query.search || null,
          searchTerm: this.$route.query.searchTerm || null,
          // Send the raw filtered total (not pre-reduced by excludeOnlyIds), matching
          // the exclude-logic contract used by DELETE_DRAFTS/shipment/delete-list.
          count: this.get_drafts_count,
          total_count: this.get_drafts_count,
          excludeOnlyIds: option.excludeOnlyIds, // Send excluded IDs
        }
      } else {
        // Standard behavior
        payloadObject = {
          shipment_ids: option.list,
          search: null,
          searchTerm: null,
          count: null,
          total_count: null,
          excludeOnlyIds: [],
        }
      }

      this.$store.dispatch('PRINT_DRAFTS', payloadObject).then((res) => {
        this.updateIterator++;
        if (res.failed.length > 0) {
          let message = '';
          for (const property in res.messages) {
            message += `Shipment${property}:</br> ${res.messages[property]}</br>`;
          }
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: message,
            type: 'alert-window',
            iconName: 'warningSign',
          });
          return;
        }
        if (res.processed.length > 0) {
          // Pass the progress id, not the whole response object, or the
          // progress-track/${id} URL ends up as progress-track/[object Object].
          this.trackProgressValidation(res.progress_id).then(() => {
            this.updateIterator++;
          });

          // Show print success notification
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: this.$t('LBL_PRINT_STARTED_SUCCESSFULLY'),
            type: 'success-window',
            iconName: 'printer',
          });
        }
      }).catch((error) => {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('LBL_PRINT_FAILED_ERROR'),
          type: 'alert-window',
          iconName: 'warningSign',
        });
      });
    },
    trackProgressValidation(id) {
      let idOfProgress = id;
      return new Promise((resolve, reject) => {
        this.$store.dispatch('TRACK_VALIDATION_PROGRESS', idOfProgress)
          .then((res) => {
            let response = res.data.data;
            if (response !== 'progress-done') {
              this.$store.commit('STORE_UPLOAD_PROGRESS', response);
              const self = this;
              setTimeout(() => {
                this.trackProgressValidation(idOfProgress);
              }, 2000);
            } else {
              this.$store.commit('STORE_UPLOAD_PROGRESS', 100);
              this.updateIterator++;
              resolve(idOfProgress);
            }
          });
      });
    },
    navigateToCreateShipment() {
      this.$router.push('book-shipment');
    },
    optionSelected(opt) {
      if (opt === 'dropOption1') {
        this.createNewShipment();
      }
      if (opt === 'dropOption2') {
        this.openImportTemplatePopup();
      }
    },
    createNewShipment() {
      this.$router.push('/shipments/book-shipment');
    },
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
    enableImport() {
      this.showImportButton = true;
    },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
  },
  watch: {
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if (queObj.templateType == 'shipment_fields' && queObj.progressStatus == 100) {
            this.updateIterator++;
          }
        })
      },
      deep: true
    }
  }
};
</script>
